module.exports = __webpack_public_path__ + "odinstatic/v6.4.0/media/create_demand.323e9c1e.svg";